import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Params, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../retailer.service';
import { ZipCodes } from '../../../features-common/constants/ZipCodes';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
function convertStatus(value){
  return value ? 'Yes' : 'No';
}
@Component({
  selector: 'app-new-retailer',
  templateUrl: './new-retailer.component.html',
  styleUrls: ['./new-retailer.component.scss']
})
export class NewRetailerComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  @Input() salesReps
  @Input() businessTypes
  @Input() pricelists

  offHoursTransactionCount;
  offHoursTransactionAmount;
  thresholdAmount;
  usStateZips;
  addRetailerForm: FormGroup;
  emailRegx = /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  phoneRegx = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
  autoReloadStatus = false;
  autoPaymentStatus = false;
  creditLineStatus = false;
  ipAddressStatus = false;
  ivrAccess = false;
  emailNotificationStatus = false;
  transactionAmtPerhr: number[];
  smsNotificationStatus = false;
  otpMobileNumber = new FormControl();
  filteredOptions: Observable<string[]>;
  salesRepsOptions: any = [];
  accountType = new FormControl('Prepaid');
  public phone: Array<string | RegExp>
  transactionPerHr: number[];
  transactionPerHrselected: any;
  transactionAmtPerhrselected: any;
  thresholdAmountselected: any;
  offHoursTransactionAmountselected: any;
  offHoursTransactionCountselected: any;
  numberMask = createNumberMask({
    prefix: '$ ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol :',',
    allowDecimal :true,
  })
  creditLineStatusreq = false;

  constructor(private cdref: ChangeDetectorRef, private fb: FormBuilder, public dialog: MatDialog, private router: Router, private retailerService: RetailerService) {
    super();
    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }
  

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }
  allCharWithAmprecendMask(rawValue: string): RegExp[] {
    const mask = /^[.\/&\w\s]*$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }
  dollarMask(rawValue:any){
    const strLength = String(rawValue).length;
   const numberMask = createNumberMask({
      prefix: '$ ',
      suffix: '',
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol :',',
      allowDecimal :true,
    })
    for (let i = 0; i <= strLength; i++) {
      numberMask.push(numberMask);
    }

    return numberMask;
  } 
 
  charsMaskNoSpace(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9|]+$/;
    const strLength = String(rawValue).length;
    const userNameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      userNameMask.push(mask);
    }

    return userNameMask;

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['salesReps']) {
      this.salesReps = changes['salesReps'].currentValue;
      //console.log(this.salesReps);
    }
    if (changes['businessTypes']) {
      this.businessTypes = changes['businessTypes'].currentValue;
    }
    if (changes['pricelists']) {
      this.pricelists = changes['pricelists'].currentValue;
    }
  }
  radioChange(e) {
    if (e.value == 'Prepaid') {
      this.addRetailerForm.get('creditLineStatus').disable();
      this.addRetailerForm.get('createCreditLine').disable();
      this.addRetailerForm.get('creditLineStatus').setValue(false);
      this.addRetailerForm.get('createCreditLine').setValue('');
      this.addRetailerForm.controls['createCreditLine'].clearValidators();
      this.creditLineStatus = false;
      this.creditLineStatusreq = false;

    } else {
      //this.creditLineStatus = true;
      this.creditLineStatusreq = true;
      this.addRetailerForm.get('creditLineStatus').enable();
      this.addRetailerForm.get('createCreditLine').enable();
      this.addRetailerForm.controls['createCreditLine'].setValidators(Validators.required);
      
    }
    this.addRetailerForm.controls['createCreditLine'].updateValueAndValidity();
  }
  checkIsCreditline(e) {
    this.creditLineStatus = e.checked;
    if (this.creditLineStatus) {
      this.addRetailerForm.controls['createCreditLine'].setValidators(Validators.required);
    } else {
      this.addRetailerForm.controls['createCreditLine'].clearValidators();
    }
    this.addRetailerForm.controls['createCreditLine'].updateValueAndValidity();
  }
  checkIpAddressStatus(e) {
    this.ipAddressStatus = e.checked;
    if (this.ipAddressStatus) {
      this.addRetailerForm.controls['ipAddressStatus'].setValidators(Validators.required);
    } else {
      this.addRetailerForm.controls['ipAddressStatus'].clearValidators();
    }
    this.addRetailerForm.controls['ipAddressStatus'].updateValueAndValidity();
  }
  checkIsIvr(e) {
    this.ivrAccess = e.checked;
    if (this.ivrAccess) {
      this.addRetailerForm.controls['ivrNumber'].setValidators(Validators.required);
      this.addRetailerForm.controls['ivrCode'].setValidators(Validators.required);
    } else {
      this.addRetailerForm.controls['ivrCode'].clearValidators();
      this.addRetailerForm.controls['ivrNumber'].clearValidators();
    }
    this.addRetailerForm.controls['ivrNumber'].updateValueAndValidity();
    this.addRetailerForm.controls['ivrCode'].updateValueAndValidity();
  }
  checkautoReloadStatus(e) {
    this.autoReloadStatus = e.checked;
    if (this.autoReloadStatus) {
      this.addRetailerForm.controls['threshold'].setValidators(Validators.required);
      this.addRetailerForm.controls['autoReloadAmount'].setValidators(Validators.required);
    } else {
      this.addRetailerForm.controls['autoReloadAmount'].clearValidators();
      this.addRetailerForm.controls['threshold'].clearValidators();
    }
    this.addRetailerForm.controls['threshold'].updateValueAndValidity();
    this.addRetailerForm.controls['autoReloadAmount'].updateValueAndValidity();
  }
  checkautoPaymentStatus(e){
    this.autoPaymentStatus = e.checked;
  }

  checkIsTextNotify(e) {
    this.smsNotificationStatus = e.checked;
  } 
  checkEmailNotificationStatusNotify(e) {
    this.emailNotificationStatus = e.checked;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.offHoursTransactionCount = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15];
    this.offHoursTransactionCountselected = 1;
    this.offHoursTransactionAmount = [0, 25, 50, 75, 100, 125, 150, 175, 200, 250, 300];
    this.offHoursTransactionAmountselected = 25;
    this.thresholdAmount = [25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 300];
    this.thresholdAmountselected = '';
    this.transactionAmtPerhr = [0, 50, 100, 200, 300, 400, 1000,1500];
    this.transactionAmtPerhrselected = 200;
    this.transactionPerHr = [10, 20, 30, 40, 50];
    this.transactionPerHrselected =30;
    this.usStateZips = ZipCodes.USAStatesShort;

    this.initForm();
    this.filteredOptions = this.addRetailerForm.get('assignSalesReps').valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.salesRepsOptions.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private initForm() {
    this.addRetailerForm = this.fb.group({
      accountType: this.accountType,
      businessName: ['', [Validators.required]],
      businessType: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      businessNumber: ['', [Validators.required, Validators.pattern(this.phoneRegx)]],
      dbaName: ['', [Validators.required]],
      address: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zipCode: ['', [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')]],
      //retailerStatus:['',[Validators.required]],
      userName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(this.emailRegx)]],
      otpMobileNumber: ['', [Validators.required, Validators.pattern(this.phoneRegx)]],
      language:['English',[Validators.required]],
      businessCertificate: ['NA', [Validators.required, Validators.pattern('^[a-zA-Z0-9_.-]*$')]],
      confirmationNumber: [''],
      assignPriceList: ['', [Validators.required]],
      assignSalesReps: ['', [Validators.required]],
      paymentOption: ['ACH', [Validators.required]],
      invoiceOption: ['Weekly', [Validators.required]],
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', [Validators.required]],
      emailNotificationStatus: this.emailNotificationStatus,
      smsNotificationStatus: this.smsNotificationStatus,
      ipAddressStatus: this.ipAddressStatus,
      ipAddress: [''],
      ivrAccess: this.ivrAccess,
      ivrNumber: [''],
      ivrCode: [''],
      autoReloadStatus: this.autoReloadStatus,
      autoPaymentStatus: this.autoPaymentStatus,
      autoReloadAmount: [''],
      threshold: [''],
      transactionCountPerhr: [30, [Validators.required]],
      transactionAmtPerhrLimit: [200, [Validators.required]],
      offTransactionCountPerhr: [1, [Validators.required]],
      offTransactionAmtPerhr: [25, [Validators.required]],
      creditLineStatus: this.creditLineStatus,
      createCreditLine: [''],
    })
  }

  get f() {
    return this.addRetailerForm.controls;
  }

  onSubmit() {
    //console.log(this.addRetailerForm);
    if (this.addRetailerForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.addRetailerForm)
        }
      });

    }
    //console.log(this.addRetailerForm.value.businessNumber.replace(/\D/g, ''))
  }

  setSubmitParameters(addRetailerForm: FormGroup) {
    //IP address filters
    function ValidateIPaddress(ipaddress) {

      if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
        return (true)
      }
      return (false)
    }

    let ipaddresses = addRetailerForm.get('ipAddress').value
    let ipaddresses_array = ipaddresses.split(';');

    ipaddresses_array.forEach(function (address) {
      //console.log(address + " " + ValidateIPaddress(address));
    }
    );
    let httpParams: Params = {
      accountType: addRetailerForm.get('accountType').value,
      businessName: addRetailerForm.get('businessName').value,
      businessType: addRetailerForm.get('businessType').value,
      businessNumber: addRetailerForm.get('businessNumber').value,
      dbaName: addRetailerForm.get('dbaName').value,
      address: addRetailerForm.get('address').value,
      city: addRetailerForm.get('city').value,
      state: addRetailerForm.get('state').value,
      zipCode: addRetailerForm.get('zipCode').value.toString(),
      email: addRetailerForm.get('email').value,
      otpMobileNumber:  addRetailerForm.get('otpMobileNumber').value,
      businessCertificate: addRetailerForm.get('businessCertificate').value.toString(),
      language: addRetailerForm.get('language').value.toString(),
      confirmationNumber: addRetailerForm.get('confirmationNumber') ? addRetailerForm.get('confirmationNumber').value?.toString() : null,
      assignPriceList: addRetailerForm.get('assignPriceList').value,
      assignSalesReps: addRetailerForm.get('assignSalesReps').value,
      paymentOption: addRetailerForm.get('paymentOption').value,
      invoiceOption: addRetailerForm.get('invoiceOption').value,
      firstName: addRetailerForm.get('firstName').value,
      lastName: addRetailerForm.get('lastName').value,
      userName: addRetailerForm.get('userName').value,
      smsNotificationStatus: convertStatus(this.smsNotificationStatus),
     
      smsNotification: addRetailerForm.get('otpMobileNumber').value,

      emailNotificationStatus: convertStatus(this.emailNotificationStatus),
      emailNotification: addRetailerForm.get('email').value,
      ipAddressStatus: convertStatus(this.ipAddressStatus),
      ipAddress: addRetailerForm.get('ipAddress').value,
      ivrAccess: convertStatus(this.ivrAccess),
      ivrNumber: addRetailerForm.get('ivrNumber').value,
      ivrCode: addRetailerForm.get('ivrCode').value,
      autoReloadStatus: convertStatus(this.autoReloadStatus),
      autoPaymentStatus: convertStatus(this.autoPaymentStatus),
      autoReloadAmount: addRetailerForm.get('autoReloadAmount').value.replace('$','').replace(',','').replace(' ',''),
      threshold: addRetailerForm.get('threshold').value,
      transactionCountPerhr: addRetailerForm.get('transactionCountPerhr').value,
      transactionAmtPerhr: addRetailerForm.get('transactionAmtPerhrLimit').value,
      offTransactionCountPerhr: addRetailerForm.get('offTransactionCountPerhr').value,
      offTransactionAmtPerhr: addRetailerForm.get('offTransactionAmtPerhr').value,
      creditLineStatus: convertStatus(this.creditLineStatus),
      createCreditLine: addRetailerForm.get('createCreditLine').value.replace('$','').replace(',','').replace(' ',''),
    }
    this.retailerService.addNewRetailer(httpParams).subscribe(res => {
      if (res && res) {
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_110") || res.responseStatus == 'Success'){
          this.router.navigate(['features/retailers/allretailers'])
          let _message = 'User Name :' + res.data.RetailerUserName + ' Account No# :' + res.data.RetailerAccountNum + '  Retailer added successfully'
          this.toastrService.success(_message, 'Success', {
            timeOut: 3000,
          });        
      }
        else if (res && res.httpcode == 400) {
          Swal.fire(
            {
              title: res.responseStatus,
              text: res.userMessage,
              icon: 'error',
              timer: 2000,
            }
          )
        } else {
          Swal.fire(
            {
              title: res.responseStatus,
              text: res.userMessage,
              icon: 'error',
              timer: 2000,
              willClose: () => {

              }
            })
        }
      }
    });
  }






  onCancel() {
    // for (const name in this.addRetailerForm.controls) {
    //   if (this.addRetailerForm.controls[name].invalid) {
    //     console.log("Invalid " + name);
    //   } else {
    //     console.log("Valid " + name);
    //   }
    // }

    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      }
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.addRetailerForm.reset()
        this.router.navigate(['features/retailers/allretailers'])
      }
    });
  }
  onsalesrepSelected(e: MatSelectChange){
    let _salesrep = e.value;
    let params: any = {
      salesRepId:_salesrep
    }
    this.retailerService.getPricelists(params).subscribe(
      res => {
        let data: any = res;
        if (data.httpcode == 200) {
          this.pricelists = data.data;
          
        }
      });
    }
}